function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import Backbone from '@polleverywhere/backbone';
import _ from 'underscore';

function check(delay) {
  if (delay === void 0) {
    delay = this.pollingInterval;
  }

  if (delay > 0) {
    this.timeoutId = setTimeout(this.destroy.bind(this), delay);
  } else {
    return this.destroy();
  }
}

function resetTimeout() {
  clearTimeout(this.timeoutId);
  return delete this.timeoutId;
}
/*
 * Out of band authentication code model. An out of band authentication code is
 * exchanged (consumed) for a session by a browser that cannot sign in to SSO
 * providers. For example, the embedded browser used in the presentation
 * applications cannot sign in via Google SSO. An out of band authentication
 * code can be created via the embedded browser which then opens an
 * authentication endpoint in another browser. The user's session in the
 * external browser can be associated with the out of band code and the accessed
 * in the embedded browser.
 *
 * @namespace Model
 *
 * @event completed Code has been used to create session
 *
 * @event failed Error fetching code status @param [XHR] xhr XHR Request
 *
 */


var OutOfBandAuthenticationCode = /*#__PURE__*/function (_Backbone$Model) {
  _inheritsLoose(OutOfBandAuthenticationCode, _Backbone$Model);

  function OutOfBandAuthenticationCode() {
    return _Backbone$Model.apply(this, arguments) || this;
  }

  var _proto = OutOfBandAuthenticationCode.prototype;
  /*
   * @param [Object] options
   * @param options [Number] pollingInterval - Set polling interval in milliseconds
   * @return [Object] The out of band authentication code instance
   *
   */

  _proto.initialize = function initialize(options) {
    if (options === void 0) {
      options = {};
    }

    _.defaults(options, {
      pollingInterval: 2000
    });

    var interval = parseInt(options.pollingInterval);

    if (isNaN(interval)) {
      throw new Error('`options.pollingInterval` must be a number.');
    } else {
      this.pollingInterval = interval;
    }

    this.stopChecking();
    return this;
  }
  /*
   * @return [Object] The out of band authentication code instance
   *
   */
  ;

  _proto.startChecking = function startChecking() {
    this.isPolling = true;

    if (!this.timeoutId) {
      check.call(this, 0);
    }

    return this;
  }
  /*
   * @return [Object] The out of band authentication code instance
   *
   */
  ;

  _proto.stopChecking = function stopChecking() {
    this.isPolling = false;
    return this;
  };

  _proto.destroy = function destroy() {
    var _this = this;

    if (this.isPolling) {
      return _Backbone$Model.prototype.destroy.call(this, {
        success: function success() {
          _this.stopChecking();

          _this.trigger('completed');
        },
        error: function error(_model, xhr) {
          if (xhr.status === 404) {
            return check.call(_this);
          }

          resetTimeout.call(_this);
          return _this.trigger('failed', _this, xhr);
        }
      });
    } else {
      return resetTimeout.call(this);
    }
  };

  _createClass(OutOfBandAuthenticationCode, [{
    key: "urlRoot",
    get: function get() {
      return '/auth/out_of_band_authentication_codes';
    }
  }, {
    key: "idAttribute",
    get: function get() {
      return 'code';
    }
  }]);

  return OutOfBandAuthenticationCode;
}(Backbone.Model);

export { OutOfBandAuthenticationCode as default };